import state from '@/store/module_login/state'
import mutations from '@/store/module_login/mutations'
import actions from '@/store/module_login/actions'

export default ({
  state,
  mutations,
  actions,
})